import React, { memo } from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  newTabSrOnly: {
    id: 'person.link.newtab.sronly',
    defaultMessage: '(opens in new tab)',
  },
});

export const BrItem = memo(
  ({
    icon,
    children,
    href,
    section,
    openLinkInNewTab,
    ariaLabel,
    className,
    isEditMode = false,
    ...rest
  }) => {
    const classNameFinal = cx(className, 'br-item');

    const intl = useIntl();
    const content = (
      <span className="d-flex align-items-baseline gap-1 w-100">
        {icon && <i className={icon} aria-hidden="true" />}
        <span className="flex-fill">{children}</span>
      </span>
    );

    if (section) {
      return (
        <div
          className={`${classNameFinal} mx-0`}
          aria-label={ariaLabel || section}
          {...rest}
        >
          <div className="text-weight-semi-bold text-base mb-0">{section}</div>
        </div>
      );
    }

    const relValue = openLinkInNewTab ? 'noopener noreferrer' : undefined;
    const disabled = isEditMode || !href;
    return (
      <ConditionalLink
        condition={!disabled}
        href={href}
        className={cx(classNameFinal)}
        target={openLinkInNewTab && !disabled ? '_blank' : undefined}
        rel={openLinkInNewTab && !disabled ? relValue : undefined}
        aria-label={ariaLabel}
        aria-disabled={disabled || undefined}
        {...rest}
      >
        <MaybeWrap
          as={'button'}
          condition={isEditMode && href}
          className={cx(classNameFinal, 'disabled')}
        >
          {content}
          {openLinkInNewTab && !disabled && (
            <span className="sr-only">
              {intl.formatMessage(messages.newTabSrOnly)}
            </span>
          )}
        </MaybeWrap>
      </ConditionalLink>
    );
  },
);

BrItem.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  section: PropTypes.string,
  openLinkInNewTab: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  isEditMode: PropTypes.bool,
};
